// Guard the HTMLElement reference so importing the embed package on a server
// (Next.js SSR, SSR/SSG frameworks, jest without jsdom) doesn't crash. The
// fallback class is never instantiated server-side — every web component's
// register*() entry point is a no-op when window/customElements are absent.
export const BaseElement: typeof HTMLElement =
  typeof HTMLElement !== 'undefined' ? HTMLElement : (class {} as unknown as typeof HTMLElement)

/**
 * Register a custom element idempotently and safely from any environment.
 * No-op on the server (no `window`/`customElements`) and when the tag is
 * already defined elsewhere on the page.
 */
export function registerCustomElement(name: string, ctor: CustomElementConstructor): void {
  if (typeof window === 'undefined' || typeof customElements === 'undefined') return
  if (!customElements.get(name)) customElements.define(name, ctor)
}
